//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime, formatTrueFalse } from './../../components/helpers.js'
import { axiosGet } from './../../axios/axios.js'

import DateTimeField from './../../components/Field/DateTimeField.vue'

export default {
  components: {
    DateTimeField
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      departments: [],
      projects: [],
      projectsOptions: []
    }
  },
  computed: {
    readonly: function () {
      return this.orderAdmittance.state !== 'AD0' && this.orderAdmittance.state !== 'AD1' && this.orderAdmittance.state !== 'AD2'
    }
  },
  created: function () {
    this.loadDepartments()
    this.loadProjects()
  },
  methods: {
    filterFn (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.projectsOptions = this.projects.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    },
    formatDataFromUnixTime: function (unixTime) {
      if (unixTime) {
        return convertTime(unixTime)
      } else {
        return 'Нет данных'
      }
    },
    getEndWorkTimeColor: function () {
      if (this.orderAdmittance.endWorkTime) {
        const time = this.orderAdmittance.endWorkTime
        if (time < new Date().getTime()) {
          return 'red'
        } else if ((time - new Date().getTime()) < 24 * 60 * 60 * 1000) {
          return 'orange'
        } else {
          return 'green'
        }
      }
    },
    setFoundation: function () {
      const foundation = this.projects.find(project => project.departments && project.departments.find(department => department.key === this.orderAdmittance.department.key))
      if (foundation) {
        this.orderAdmittance.foundation = foundation
      }
    },
    loadProjects: function () {
      this.loading = true

      axiosGet({
        url: '/service/delta/request/getProjects',
        onSuccess: (response) => {
          response.data.result.forEach((project) => {
            this.projects.push({ key: project.projectKey, name: project.projectName, departments: project.departments })
          })
          this.projectsOptions = JSON.parse(JSON.stringify(this.projects))
        },
        onFailure: 'Ошибка получения списка проектов',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    loadDepartments: function () {
      this.loading = formatTrueFalse

      const params = [{ param: 'orderNumber', type: 'integer', action: 'any' }, { param: 'commentText', type: 'string', action: 'any' }]
      const encodeParams = encodeURI(JSON.stringify(params))

      axiosGet({
        url: '/service/obj/search?params=' + encodeParams + 'nameField=name&type=department&limit=1000&sort=name&dir=ASC',
        onSuccess: (response) => {
          this.departments = response.data.result
          const departmentName = this.$store.getters.getUser.employee ? this.$store.getters.getUser.employee.departmentName : null
          this.departments.sort((a, b) => {
            return a.name == departmentName ? -1 : b.name == departmentName ? 1 : 0
          })
        },
        onFailure: 'Ошибка загрузки списка отделов',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

